import generateUniqueID from "utils/generateUniqueID";
import {
  getRandomDomain,
  getRandomNumber,
  getRandomStatus,
} from "utils/random";
import { isValidValue } from "utils/validation";

export const setDomainData = (el = {}) => {
  return {
    createdAt: el.CreatedAt ?? el.created_at ?? null,
    district_id: el.district_id ?? null,
    updatedAt: el.UpdatedAt ?? el.updated_at ?? null,
    deletedAt: el.DeletedAt ?? el.deleted_at ?? null,
    id: el.ID ?? el.id ?? null,
    num_users: el.users_count || 0,
    name: el.domain || null,
    status: isValidValue(el.is_active)
      ? el.is_active
        ? "active"
        : ("deactivated" ?? null)
      : null,
  };
};
export const defaultDomainData = (el = {}) => {
  const date = new Date();
  return {
    CreatedAt: date,
    UpdatedAt: null,
    DeletedAt: null,
    ID: generateUniqueID(),
    num_users: getRandomNumber(),
    domain: el?.domain ?? getRandomDomain(),
    status: el?.status ?? getRandomStatus(),
    is_active: getRandomStatus(true),
  };
};
